import React from 'react'
import PropTypes from 'prop-types'

import TopHeaderRow from './TopHeaderRow'
import BottomHeaderRowJob from './BottomHeaderRowJob'
import BottomHeaderRowPriceOffer from './BottomHeaderRowPriceOffer'
import JobConversationTitle from './JobConversationTitle'
import PriceOfferConversationTitle from './PriceOffer/PriceOfferConversationTitle'
import FileConversionRequestTitle from './FileConversionRequestTitle'

const HeaderWithTwoLines = (props) => {
  const TitleElement = (() => {
    switch (props.type) {
      case 'job_application':
        return <JobConversationTitle url={props.typeData.url} title={props.typeData.title} />
      case 'offer':
        return <PriceOfferConversationTitle itemUrl={props.typeData.itemUrl} itemTitle={props.typeData.itemTitle} />
      case 'file_conversion_request':
        return <FileConversionRequestTitle itemUrl={props.typeData.itemUrl} itemTitle={props.typeData.itemTitle} />
    }
  })()

  return (
    <div>
      <div className="conversation__header">
        <TopHeaderRow
          archived={props.archived}
          reported={props.reported}
          titleElement={TitleElement}
          onReportSuccess={props.onReportSuccess}
          onMoveToArchiveSuccess={props.onMoveToArchiveSuccess}
          conversationId={props.conversationId}
          recipient={props.recipient}
        />
        {{
          job_application: (
            <BottomHeaderRowJob jobId={props.typeData.id} role={props.typeData.role} />
          ),
          offer: (
            <BottomHeaderRowPriceOffer
              typeData={props.typeData}
              onRemoveOfferSuccess={props.onRemoveOfferSuccess}
              onPriceOfferSubmitSuccess={props.onPriceOfferSubmitSuccess}
              onPriceOfferDecisionSuccess={props.onPriceOfferDecisionSuccess}
              conversationId={props.conversationId}
            />
          ),
        }[props.type]}
      </div>
    </div>
  )
}

HeaderWithTwoLines.propTypes = {
  onMoveToArchiveSuccess: PropTypes.func.isRequired,
  onReportSuccess: PropTypes.func.isRequired,
  onRemoveOfferSuccess: PropTypes.func.isRequired,
  typeData: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  onPriceOfferSubmitSuccess: PropTypes.func.isRequired,
  onPriceOfferDecisionSuccess: PropTypes.func.isRequired,
  recipient: PropTypes.string.isRequired,
}

export default HeaderWithTwoLines
